/**
 * Structure of object page saved to prefs
 */
import {ObjectAccessFlag} from "@t/security/ObjectAccess.ts";

export interface SubviewBlock<T> {
	id?: number;
	tabs: T[];
}

export interface SubviewStructure {
	RIGHT?: SubviewBlock<string>[];
	BOTTOM?: SubviewBlock<string>[];
}

export const DEFAULT_SUBVIEW:Subview = {
	layout: 'COLUMNS',
	structure: { RIGHT: [], BOTTOM: [] }
};

export interface Subview {
	/**
	 * How is the page primarily divided
	 */
	layout: "ROWS" | "COLUMNS";
	structure: SubviewStructure;
}

export interface SubviewTab {
	name: string;

	/**
	 * All subview must have content specified by one of these methods:
	 * src - use this to put URL of server page with loadable content
	 * component - Vue component name (at runtime translate to real Vue instance)
	 **/
	src?: string;
	component?: string;
	bind?: {
		[key:string]: string | number
	},

	title?: string;
	icon?: string;
	badge?: string;
	priority?: number;
	show?: boolean;
	/**
	 * By default subviews are shown to the user only when he edits existing record with known identity and not at creation stage (no known ID).
	 * If you need the subview to be shown even at creation set this to true.
	 **/
	showOnCreate?: boolean;
	/**
	 * This subview will be visible only if the parent object has this required access flag
	 */
	requireAccess?: ObjectAccessFlag;
	placement?: "right" | "bottom" | "standalone";
	/** Backend will be queried for badge info (see /api/subviews/badges) */
	counted?: boolean;
}


export interface SubviewBadgeInfo {
	name: string;
	badge?: string;
	collapsed?: boolean;
}

// Input and also Output of /api/subviews/badges
export type SubviewBadgePayload = SubviewBadgeInfo[];